import { checkStatus, getHeaders, parseJSON, buildUrlWithQuery } from '@/utils/api'
import { http } from '@/plugins/http'

export async function fetchLinesNew ({ trxIds, type, pageSize }) {
  if (!pageSize) {
    pageSize = 200
  }
  const query = { page_size: pageSize, transaction__id__in: trxIds }
  const url = buildUrlWithQuery(`lines/${type}`, query, this.getters.getActiveInstance.url)
  const headers = getHeaders(this.getters.getToken)
  try {
    const firstPage = await http.get(url, { headers })
      .then(checkStatus)
      .then(parseJSON)
    if (!(firstPage && firstPage.results)) {
      throw new Error(`Unable to fetch first page of lines for the following line IDs: ${trxIds.toString()}`)
    }
    let lines = [...firstPage.results]
    let pageCount = firstPage.page_count || 1
    if (pageCount <= 1) {
      return lines
    }
    let pageRequests = []
    let page = 2
    while (page <= pageCount) {
      pageRequests.push(http.get(url + `&page=${page}`, { headers }))
      page++
    }
    for (const request of pageRequests) {
      const resp = await request
        .then(checkStatus)
        .then(parseJSON)
      lines = [...lines, ...resp.results]
    }
    return lines
  } catch (e) {
    console.log(e)
  }
}

export async function fetchLines ({ lineIds, type, pageSize }) {
  if (!pageSize) {
    pageSize = lineIds.length > 100 ? 50 : 100
  }
  const query = { page_size: pageSize, id__in: lineIds }
  const url = buildUrlWithQuery(`lines/${type}`, query, this.getters.getActiveInstance.url)
  const headers = getHeaders(this.getters.getToken)
  try {
    const firstPage = await http.get(url, { headers })
      .then(checkStatus)
      .then(parseJSON)
    if (!(firstPage && firstPage.results)) {
      throw new Error(`Unable to fetch first page of lines for the following line IDs: ${lineIds.toString()}`)
    }
    let lines = [...firstPage.results]
    let pageCount = firstPage.page_count || 1
    if (pageCount <= 1) {
      return lines
    }
    let pageRequests = []
    let page = 2
    while (page <= pageCount) {
      pageRequests.push(http.get(url + `&page=${page}`, { headers }))
      page++
    }
    for (const request of pageRequests) {
      const resp = await request
        .then(checkStatus)
        .then(parseJSON)
      lines = [...lines, ...resp.results]
    }
    return lines
  } catch (e) {
    console.log(e)
  }
}

export function getLineIds (transactions) {
  if (!Array.isArray(transactions)) {
    transactions = Object.values(transactions)
  }

  // Handle transctions lines as both primary keys and objects
  let lineIds = [...new Set([].concat(...transactions.map(trx => trx.lines.map((line) => (typeof line === 'object') ? line.id : line))))]
  return lineIds
}

export function getTrxIds (transactions) {
  if (!Array.isArray(transactions)) {
    transactions = Object.values(transactions)
  }

  let trxIds = [...new Set(transactions.map(trx => trx.id))]
  return trxIds
}
